<template>
  <div class="layout-use-of-bar-content" id="identidade-visual-combinando-os-assets-uso-de-barra" data-search-anchor>
    <div class="title-layout-use-of-bar-wrapper">
      <h1 class="layout-use-of-bar-title-span">{{ layoutUseOfBarTitleSpan }}</h1>
      <h1 class="layout-use-of-bar-title">{{ layoutUseOfBarTitle }}</h1>
    </div>
    <div class="descriptiom-layout-use-of-bar-wrapper">
      <p class="layout-use-of-bar-description" style="padding-left: 0; margin-top: 0;">{{ layoutUseOfBarDescription }}</p>
      <p class="layout-use-of-bar-description" style="padding-left: 0; margin-top: 0;">{{ layoutUseOfBarDescription1 }}</p>
      
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-use-of-bar-description">{{ layoutUseOfBarDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-use-of-bar-description">{{ layoutUseOfBarDescription3 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-use-of-bar-description">{{ layoutUseOfBarDescription4 }}</p>
      </div>
    </div>
    <div
      class="layout-use-of-bar-card-item"
      :style="{ backgroundImage: `url(${layoutUseOfBarImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LayoutsUseOfBarSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutUseOfBarTitleSpan(): string {
    return this.getElementTitle(8, 0)
  }

  get layoutUseOfBarTitle(): string {
    return this.getElementText(8, 0)
  }

  get layoutUseOfBarDescription(): string {
    return this.getElementText(8, 1)
  }

  get layoutUseOfBarDescription1(): string {
    return this.getElementText(8, 2)
  }

  get layoutUseOfBarDescription2(): string {
    return this.getElementText(8, 3)
  }

  get layoutUseOfBarDescription3(): string {
    return this.getElementText(8, 4)
  }

  get layoutUseOfBarDescription4(): string {
    return this.getElementText(8, 5)
  }

  get layoutUseOfBarImageSrc(): string {
    return this.getElementMedia(8, 6)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-use-of-bar-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-layout-use-of-bar-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding: 6.25rem 0rem 2rem 0rem;
}

.layout-use-of-bar-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #b3b3b3;
}
.layout-use-of-bar-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.descriptiom-layout-use-of-bar-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%; 
  padding-bottom: 1rem; 
}

.layout-use-of-bar-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;  
}

.title-image {  
  font-size: 20px;
  font-weight: 600;
  text-align: left;

  padding-left: 3rem;
  width: 187px;
}

.layout-use-of-bar-card-item {
  position: relative;   

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
